import React from "react";

// size defaults to the basic viewers per-viewport button; the Advance Viewer toolbar
// passes 20 to match the icons either side of it.
const Impression = ({ color, size = 29 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 29 29"
      fill="none"
    >
      <g clipPath="url(#clip0_5599_176973)">
        <path
          d="M22.9583 3.6237H17.9075C17.4 2.22203 16.0708 1.20703 14.5 1.20703C12.9292 1.20703 11.6 2.22203 11.0925 3.6237H6.04167C4.7125 3.6237 3.625 4.7112 3.625 6.04036V22.957C3.625 24.2862 4.7125 25.3737 6.04167 25.3737H22.9583C24.2875 25.3737 25.375 24.2862 25.375 22.957V6.04036C25.375 4.7112 24.2875 3.6237 22.9583 3.6237ZM14.5 3.6237C15.1646 3.6237 15.7083 4.16745 15.7083 4.83203C15.7083 5.49661 15.1646 6.04036 14.5 6.04036C13.8354 6.04036 13.2917 5.49661 13.2917 4.83203C13.2917 4.16745 13.8354 3.6237 14.5 3.6237ZM16.9167 20.5404H8.45833V18.1237H16.9167V20.5404ZM20.5417 15.707H8.45833V13.2904H20.5417V15.707ZM20.5417 10.8737H8.45833V8.45703H20.5417V10.8737Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5599_176973">
          <rect width="29" height="29" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Impression;
